import { render, staticRenderFns } from "./VerticalProgressBar.vue?vue&type=template&id=6890f388"
import script from "./VerticalProgressBar.vue?vue&type=script&lang=js"
export * from "./VerticalProgressBar.vue?vue&type=script&lang=js"
import style0 from "./VerticalProgressBar.vue?vue&type=style&index=0&id=6890f388&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6890f388')) {
      api.createRecord('6890f388', component.options)
    } else {
      api.reload('6890f388', component.options)
    }
    module.hot.accept("./VerticalProgressBar.vue?vue&type=template&id=6890f388", function () {
      api.rerender('6890f388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-progress-bar/progress-types/VerticalProgressBar.vue"
export default component.exports